import z, {ZodType} from "zod/v4";
import {SortOrder} from "../rpc/webrpc-client.gen.ts";
import {InspectionStageOrSurcharge} from "../inspect/stages.tsx";

import {JoyableColor} from "../components/JoyableColor.tsx";

const TieredColorBase = z.object({
    color: JoyableColor,
    watched: z.boolean(),
});
type TieredColorBase = z.infer<typeof TieredColorBase>;

export interface TieredColor<TierT extends string | number | symbol> extends TieredColorBase {
    tier: TierT;
}

export interface LiveTieredColor<TierT extends string | number | symbol> extends TieredColor<TierT> {
    sortIndex: number;
}

export function makeTieredColor<TierSchemaT extends ZodType<string | number | symbol>>(tierSchema: TierSchemaT) {
    return TieredColorBase.extend({tier: tierSchema});
}

export const AgentPreferences = z.object({
    agentSortOrder: SortOrder.default("DESC"),
    truckSortOrder: SortOrder.default("DESC"),
    bundleSortOrder: SortOrder.default("DESC"),
    wasteSortOrder: SortOrder.default("DESC"),
    sleepSeconds: z.number(),

    inspectionTierColors: z.optional(makeTieredColor(InspectionStageOrSurcharge).array()),
});
export type AgentPreferences = z.infer<typeof AgentPreferences>;

export const defaultPrefs: AgentPreferences = {
    agentSortOrder: SortOrder.enum.DESC,
    truckSortOrder: SortOrder.enum.DESC,
    bundleSortOrder: SortOrder.enum.DESC,
    wasteSortOrder: SortOrder.enum.DESC,
    // sleepSeconds: 5 * 60,
    sleepSeconds: 4 * 60 * 60,
} as const;

